<template lang="pug">
  #index
    .container
      .box
        .row
          .column.left
            img.hej-title(:src="getImgUrl('hej')")
            img.alex-tampi-m(src="../assets/images/dashboard/angna.png")
            form(method="post" @submit.prevent="login")
              //- label.form-label Mobile number
              //- br
              //- select(class="country-code", v-model="countryCode", :disabled="disableMobileInput")
              //-   option(value="65") +65
              //-   option(value="60") +60
              //- input(type="text", class="form-input mobile-number", name="membershipNumber", v-model="mobileNumber", maxlength=10, :disabled="disableMobileInput", @keydown="isNumber")
              //- span(class="errorMessage", v-show="(!this.loginForm.membershipNumber) && showError && !disableMobileInput")
              //-   strong *Invalid mobile number
              //- br
              //- p.text-center OR
              .f-cont
                label.form-label {{ $LANG.login.SMALISH_PASSPORT_NO }}
                input(type="text", class="form-input", name="membershipNumber", v-model="loginForm.membershipNumber", maxlength=16)
                span(class="errorMessage", v-show="(!this.loginForm.membershipNumber) && showError")
                  strong {{ $LANG.login.INVALID_MEMBERSHIP_NUMBER }}
              .f-cont
                label.form-label {{ $LANG.login.PASSWORD }}
                input(type="password", class="form-input", name="password", v-model="loginForm.password", maxlength=8)
                span(class="errorMessage", v-show="(!this.loginForm.password || this.loginForm.password.length !== 8) && showError")
                  strong {{ $LANG.login.INVALID_PASSWORD }}
              span(class="errorMessage", v-show="loginFailed")
                strong {{ $LANG.login.INVALID_MEMBERSHIP_NUMBER_OR_PASSWORD }}
                br
                br
              label.hint.black
                i
                  span(class="red")
                    strong {{ $LANG.login.HINT }}
                  | {{ $LANG.login.HINT_DESCRIPTION }}
                  //- br
                  | {{ $LANG.login.HINT_DATE_FORMAT }}
                  br.desktop
                  | {{ $LANG.login.HINT_EXAMPLE_DESCRIPTION }}
                  | {{ $LANG.login.HINT_PASSWORD_EXAMPLE }}
              .recaptcha-wrapper
                #recaptcha-login.g-recaptcha(data-sitekey="6LfApukeAAAAACIRTq5ZwOSPsgqVFuA52Pxin7Y2")
                span(class="errorMessage", v-show="recaptchaError")
                  strong {{ $LANG.login.PLEASE_CHECK }}
              input.submit(type="image" :src="getImgUrl('btn-submit')" alt="submit" gtm-label="login.submit")
              //- button(type="submit", class="btn-submit") Submit
          .column.right
            img(class="alex-tampi", src="../assets/images/dashboard/angna.png")
</template>
<script>
import api from '../library/api.js'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        membershipNumber: '',
        password: '',
        captcha: ''
      },
      showError: false,
      loginFailed: false,
      recaptchaError: false,
      lang: ''
    }
  },

  head: {
    script: [
      { type: 'text/javascript', src: 'https://www.google.com/recaptcha/api.js', async: true, defer: true }
    ]
  },

  created () {
    if (window.localStorage.getItem('token')) {
      this.$router.push('/' + this.$LOCALE + '/dashboard')
    }
    const currentUrl = window.location.href
    if (currentUrl.indexOf('/en/')) {
      this.lang = 'en'
    } else {
      this.lang = 'th'
    }
    console.log(this.$LOCALE)
  },

  mounted () {
    // setTimeout(() => {
    //   window.grecaptcha.render('recaptcha-login', {
    //     'sitekey': '6LfApukeAAAAACIRTq5ZwOSPsgqVFuA52Pxin7Y2'
    //   })
    // }, 500)
  },

  methods: {
    isNumber (e) {
      if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.which) !== -1 ||
        (e.which === 65 && e.ctrlKey === true) ||
        (e.which === 67 && e.ctrlKey === true) ||
        (e.which === 88 && e.ctrlKey === true) ||
        (e.which >= 35 && e.which <= 39)) {
        return
      }
      if ((e.shiftKey || (e.which < 48 || e.which > 57)) && (e.which < 96 || e.which > 105)) {
        e.preventDefault()
      }
    },

    hasError () {
      if (!this.loginForm.membershipNumber) {
        return true
      }
      if (!this.loginForm.password || this.loginForm.password.length !== 8) {
        return true
      }
      return false
    },

    getImgUrl (pic) {
      return require('../assets/images/' + pic + '-' + this.$LOCALE + '.png')
    },

    login () {
      this.showError = false
      this.loginFailed = false
      this.recaptchaError = false

      if (this.hasError()) {
        this.showError = true
        return
      }

      this.loginForm.captcha = window['g-recaptcha-response'].value

      if (!this.loginForm.captcha) {
        this.recaptchaError = true
        return
      }

      api('WebLogin', this.loginForm)
        .then(res => {
          window.localStorage.setItem('token', res)
          this.$router.push('/' + this.$LOCALE + '/dashboard')
        })
        .catch(err => {
          console.error(err)
          if (err.status === 401) {
            this.loginFailed = true
          }
          window.grecaptcha.reset()
        })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../sass/variables"

#index
  form
    +mobile
      width: 90%
      margin: auto

  .recaptcha-wrapper
    text-align: center
    margin-top: 10px
    +mobile
      display: flex
      justify-content: center
      flex-direction: column

    #recaptcha-login
      display: inline-block

  .f-cont
    margin-bottom: 10px

  .text-center
    text-align: center

  .country-code
    display: inline-block

  .mobile-number
    display: inline-block
    margin-left: 5px
    width: 230px !important

  .row::after
    content: ""
    display: table
    clear: both

  .column
    float: left

  .left
    width: 60%
    @media #{$mobile}
      width: 100%
      text-align: center
      img
        width: 100%

  .right
    width: 40%
    img
      max-width: 200px

  .red
    color: $red

  .black
    color: $black

  .submit
    max-width: 100px
    +mobile
      margin-top: 10px

  .form-label
    font-size: 1.2em
    color: $black

  .form-input
    width: 290px
    +mobile
      width: 100%

  input
    +mobile
      padding: 5px
      font-size: 16px
      line-height: 20px

  .hint
    font-size: 12px

  .box
    position: relative
    margin: 0 auto
    padding: 20px
    width: 540px
    height: 100%
    border-radius: 15px
    box-shadow: 0 0 25px #9ecaed
    background-color: #ffffff
    @media #{$mobile}
      width: 100%
      box-shadow: 0 0
      padding: 0

  .alex-tampi-m
    display: none
    @media #{$mobile}
      display: block
      margin: 0 auto
      max-width: 70%

  .alex-tampi
    position: absolute
    margin-top: 5%
    // right: -7%
    @media #{$mobile}
      display: none

  .errorMessage
    color: $red
    font-size: 12px
    display: block
    text-align: left
    +mobile
      margin-top: 5px
      text-align: center

  .hej-title
    width: 100%
    margin-bottom: 15px
</style>
